import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import fetchWrapper from "../../utils/fetch/fetchWrapper";
import adaptedImageUrl, { BASE_URL } from '../../config';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { LOCAL_STORAGE } from "../../context/LocalStorage";
import DataTableExtensions from "react-data-table-component-extensions";
import ModalDetails from "./ModalDetails";
import QuestionsDetails from "./QuestionsDetails";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

export default function Employees() {
    const [data, setData] = useState([]);
    const MySwal = withReactContent(Swal)
    const [showModal, setShowModal] = useState(false);
    const [idRowSelected, setIdRowSelected] = useState(null);
    const [imageSelected, setImageSelected] = useState(null);
    const [lightboxImage, setLightboxImage] = useState(false);
    const [showQuestions, setShowQuestions] = useState(false)

    const fetchData = () => {
        fetchWrapper()
          .doGet({
              url: "/employees",
              onSuccess: async (response) => {
                  setData(response.data.employees)
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
    }

    useEffect(() => {
        fetchData()
    }, []);

    const CustomAvatar = ({ row }) => (
        <div>
            {row &&
                [
                    <div onClick={() => setImageLightbox(adaptedImageUrl(row.avatar_url))}>
                        <img height="50px" width="50px" className="w-full  align-middle border-none shadow-lg"
                            src={adaptedImageUrl(row.avatar_url) ?? null} />
                    </div>,
                    <center><label class="form-check form-switch"> <input class="form-check-input" value={row.id} checked={row.approved_avatar == 1 ? true : false}
                        type="checkbox"
                        onChange={handleApprovedAvatarCheckboxChange} /><span
                            class="slider round"> </span></label></center>
                ]
            }

        </div>

    );

    const CustomVerificationImage = ({ row }) => (
        <div>
            {row &&
                [
                    <div onClick={() => setImageLightbox(adaptedImageUrl(row.image_url))}>
                        <img height="50px" width="50px" className="w-full  align-middle border-none shadow-lg"
                            src={adaptedImageUrl(row.image_url) ?? null} />
                    </div>,
                    <center>
                        <label>Aceptar</label>
                        <label class="form-check form-switch"><input class="form-check-input" value={row.id} data-type={row.type} checked={row.approved == 1 ? true : false}
                            type='checkbox'
                            onChange={handleApprovedVerificationImageCheckboxChange} /><span
                                class="slider round"> </span></label>
                        <label>Rechazar</label>
                        <label class="form-check form-switch"><input class="form-check-input" value={row.id} data-type={row.type} checked={row.rejected == 1 ? true : false}
                            type='checkbox'
                            onChange={handleRejectededVerificationImageCheckboxChange} /><span
                                class="slider round"> </span></label>
                    </center>
                ]
            }

        </div>

        // <div>
        //     {row &&
        //         [
        //             <a href={(BASE_URL + (row ? row.image_url : '')).replace("frontend/public", "static")}
        //                 target="_blank"><img height="50px" width="50px"
        //                     className="w-full  align-middle border-none shadow-lg"
        //                     src={(BASE_URL + (row ? row.image_url : '')).replace("frontend/public", "static")} /></a>,

        //             <center><label class="form-check form-switch"> <input class="form-check-input" value={row.id} checked={row.approved == 1 ? true : false}
        //                 type="checkbox"
        //                 onChange={handleApprovedVerificationImageCheckboxChange} /><span
        //                     class="slider round"> </span></label></center>
        //         ]
        //     }

        // </div>
    );
    const handleApprovedVerificationImageCheckboxChange = (event) => {
        var type = event.target.dataset.type;
        var idCheck = event.target.value;

        MySwal.fire({
            title: <p>¿Está seguro de cambiarle el estado a la imagen?</p>,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar',
            didOpen: () => {
            }
        }).then((result) => {
            if (result.value) {
                fetchWrapper()
          .doPost({
              url: "/approved_verification_image",
              body:{
                  verification_id: idCheck,
                  type: type
              },
              onSuccess: async (response) => {
                fetchData()
                Swal.fire(
                    'Confirmado!',
                    'Se ha cambiado el estado.',
                    'success'
                )
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
                // axios({
                //     method: "post",
                //     url: BASE_URL + "/approved_verification_image",
                //     headers: {
                //         'Authorization': token
                //     },
                //     data: {
                //         verification_id: idCheck,

                //     },
                //     timeout: 5000,
                // })
                //     .then(
                //         function (response) {
                //             if (response.data.status == 200) {
                //                 fetchData()
                //                 Swal.fire(
                //                     'Confirmado!',
                //                     'Se ha cambiado el estado.',
                //                     'success'
                //                 )
                //             }

                //         }.bind(this)
                //     )
                //     .catch(function (error) {
                //         if (error.response) {
                //             console.log(error.message);
                //             // console.log(response.data.message);
                //             alert(response.data.message);
                //         } else if (error.request) {
                //             alert("Error de conexion");
                //         } else {
                //             // console.log(error.message);
                //             alert(error.message);
                //         }
                //     });
            }
        })
    }

    const handleRejectededVerificationImageCheckboxChange = (event) => {
        var type = event.target.dataset.type;
        var idCheck = event.target.value;

        MySwal.fire({
            title: <p>Esta seguro de cambiarle el estado a la imagen?</p>,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar',
            didOpen: () => {
            }
        }).then((result) => {
            if (result.value) {
                fetchWrapper()
          .doPost({
              url: "/Rejected_verification_image",
              body:{
                  verification_id: idCheck,
                  type: type
              },
              onSuccess: async (response) => {
                fetchData()
                Swal.fire(
                    'Confirmado!',
                    'Se ha cambiado el estado.',
                    'success'
                )
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
                // axios({
                //     method: "post",
                //     url: BASE_URL + "/Rejected_verification_image",
                //     headers: {
                //         'Authorization': token
                //     },
                //     data: {
                //         verification_id: idCheck,

                //     },
                //     timeout: 5000,
                // })
                //     .then(
                //         function (response) {
                //             if (response.data.status == 200) {
                //                 fetchData()
                //                 Swal.fire(
                //                     'Confirmado!',
                //                     'Se ha cambiado el estado.',
                //                     'success'
                //                 )
                //             }

                //         }.bind(this)
                //     )
                //     .catch(function (error) {
                //         if (error.response) {
                //             console.log(error.message);
                //             // console.log(response.data.message);
                //             alert(response.data.message);
                //         } else if (error.request) {
                //             alert("Error de conexion");
                //         } else {
                //             // console.log(error.message);
                //             alert(error.message);
                //         }
                //     });
            }
        })
    }

    const handleApprovedAvatarCheckboxChange = (event) => {
        var idCheck = event.target.value;

        MySwal.fire({
            title: <p>Esta seguro de cambiarle el estado a la imagen?</p>,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar',
            didOpen: () => {
            }
        }).then((result) => {
            if (result.value) {
                fetchWrapper()
          .doPost({
              url: "/approved_avatar",
              body:{
                  profile_id: idCheck
              },
              onSuccess: async (response) => {
                fetchData()
                Swal.fire(
                    'Confirmado!',
                    'Se ha cambiado el estado.',
                    'success'
                )
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
            }
        })
    }
    const handleActiveKitChange = (event) => {
        var idCheck = event.target.value;
        console.log(event)

        MySwal.fire({
            title: <p>¿Está seguro de cambiar el estado del Kit?</p>,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar',
            didOpen: () => {
            }
        }).then((result) => {
            if (result.value) {
                fetchWrapper()
          .doPost({
              url: "/percentage",
              body:{
                  user_id: idCheck
              },
              onSuccess: async (response) => {
                  fetchData()
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
            }
        })
    }
    const handleActiveCheckboxChange = (event) => {
        var idCheck = event.target.value;

        MySwal.fire({
            title: <p>Esta seguro de cambiarle el estado al usuario</p>,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar',
            didOpen: () => {
            }
        }).then((result) => {
            if (result.value) {
                fetchWrapper()
          .doPost({
              url: "/active_desactive_profile",
              body:{
                  profile_id: idCheck
              },
              onSuccess: async (response) => {
                  fetchData()
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
            }
        })
    }

    const setImageLightbox = (image_url) => {
        setImageSelected(image_url)
        setLightboxImage(true)
    }

    const editModal = (id) => {
        setIdRowSelected(id)
        setShowModal(true)
    }
    const editQuestions = (id) => {
        setIdRowSelected(id)
        setShowQuestions(true)
    }
    const columns = [

        {
            name: 'Avatar',
            grow: 0,
            cell: row => <CustomAvatar row={row} />,
        },
        {
            name: "Rut",
            selector: "rut",
            sortable: true,
        },
        {
            name: "Email",
            selector: "email",
            grow: 3,
            sortable: true,
        },
        {
            name: "Telefono",
            selector: "phone",
            grow: 3,
            sortable: true,
        },
        {
            name: "Nombre",
            selector: "first_name",
            grow: 0,
            sortable: true,
        },
        {
            name: "Apellido",
            selector: "last_name",
            grow: 0,
            sortable: true,
        },
        {
            name: "Genero",
            selector: "gender",
            grow: 0,
            sortable: true,
        },
        {
            name: "Fecha",
            selector: "date",
            grow: 3,
            sortable: true,
        },
        {
            name: "Direccion",
            selector: "address",
            grow: 3,
          },
          {
            name: "Departamento",
            selector: "department",
            grow: 3,
          },
        {
            name: 'Carnet Frontal',
            grow: 0,
            cell: row => <CustomVerificationImage row={row.verifications.filter(obj => {
                return obj.type === 'front_card'
            })[0]} />,
        },
        {
            name: 'Carnet Reverso',
            grow: 0,
            cell: row => <CustomVerificationImage row={row.verifications.filter(obj => {
                return obj.type === 'reverse_card'
            })[0]} />,
        },
        {
            name: 'Licencia de conducir',
            grow: 0,
            cell: row => <CustomVerificationImage row={row.verifications.filter(obj => {
                return obj.type === 'driver_license'
            })[0]} />,
        },
        {
            name: 'Certificado de antecedentes',
            grow: 0,
            cell: row => <CustomVerificationImage row={row.verifications.filter(obj => {
                return obj.type === 'background_certificate'
            })[0]} />,
        },
        {
            name: 'Certificado de residencia',
            grow: 0,
            cell: row => <CustomVerificationImage row={row.verifications.filter(obj => {
                return obj.type === 'circulation_permit'
            })[0]} />,
        },
        {
            name: 'Ver Preguntas',
            cell: row => <a onClick={() => editQuestions(row.id)}><i class="fas fa-eye"></i></a>,
        },
        {
            name: '20%/30%',
            cell: row => <label class="form-check form-switch"> <input class="form-check-input" value={row.id} checked={row.kit == 1 ? true : false}
                type="checkbox" onChange={handleActiveKitChange} /><span
                    class="slider round"> </span></label>,
        },
        {
            name: 'Activar/Desactivar Usuario',
            cell: row => <label class="form-check form-switch"> <input class="form-check-input" value={row.id} checked={row.active == 1 ? true : false}
                type="checkbox" onChange={handleActiveCheckboxChange} /><span
                    class="slider round"> </span></label>,
        },
        {
            name: 'Ver detalle',
            cell: row => <a onClick={() => editModal(row.id)}><i class="fas fa-eye"></i></a>,
        },
        {
            name: "Puntaje",
            selector: "score",
            grow: 0,
            sortable: true,
        },
    ];
    const tableData = {
        columns,
        data
    };
    return (
        <>
            <ModalDetails
                showModal={showModal}
                setShowModal={setShowModal}
                id={idRowSelected}
                setId={setIdRowSelected}
                fetchData={fetchData}
            />
            <QuestionsDetails
                showModal={showQuestions}
                setShowModal={setShowQuestions}
                id={idRowSelected}
                setId={setIdRowSelected}
                fetchData={fetchData}
            />
            {lightboxImage && (
                <Lightbox
                    mainSrc={imageSelected}
                    onCloseRequest={() => setLightboxImage(false)}
                />
            )}
            <DataTableExtensions {...tableData}>

                <DataTable
                    title="Empleados" 
                    columns={columns}
                    data={data}
                    pagination
                    paginationPerPage={10}
                />
            </DataTableExtensions>

        </>
    );
}
